import { Injectable } from "@angular/core";
import { ApiStore } from "@fry/lib/store";
import { APIService } from "@fry/lib/api";
 import {
  Connection,
  DetailedConnectionType,
  ExamTypeEnum
} from "./connection";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";


export interface InitRegistrationResponse {
  id: string;
  rev: string;
  redirect_url: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConnectionsStore extends ApiStore<Connection> {
  AssociatedModel = Connection;

  docType = 'connection';
  endpoint = '/v2/connection';

  constructor(
    api: APIService
  ) {
    super(api);
  }

  initRegistration(connection: Connection): Observable<InitRegistrationResponse> {
    return this.api.post(`${this.endpoint}/registration/init`, connection.doc);
  }

  reconnect(connectionId: string, host: string): Observable<InitRegistrationResponse> {
    return this.api.post(`${this.endpoint}/${connectionId}/registration/reconnect`, {host: host});
  }

  cancelRegistration(connectionId: string): Observable<any> {
    return this.api.post(`${this.endpoint}/${connectionId}/registration/cancel`, {});
  }

  completeRegistration(oauthState: string, oauthCode: string): Observable<Connection> {
    return this.api.post(`${this.endpoint}/registration/complete`, { oauthState, oauthCode });
  }

  update(connectionId: string, userFieldId: string): Observable<Connection> {
    return this.api.put(`${this.endpoint}/${connectionId}/edit`, { userFieldId });
  }

  allByConnectionType(connectionTypeId: string): Observable<Connection[]> {
    return this.all()
      .pipe(
        map(connections => connections.filter(connection => connection.connectionType === connectionTypeId)),
        catchError(error => {
          console.log('Received an error:', error.message);
          return throwError(error);
        }),
      );
  }

  getAvailableTypes(): Observable<DetailedConnectionType[]> {
    const appId = "risr-apply";
    return this.api.get(`${this.endpoint}/available-types/${appId}`)
      .pipe(
        catchError(error => {
          console.log('Received an error:', error.message);
          return throwError(error);
        }),
      );
  }

  // risr/assess
  getRisrAssessBlueprints(connectionId: string, examType?: ExamTypeEnum): Observable<any> {
    return this.api.get(`${this.endpoint}/${connectionId}/risr-assess/blueprints`, { examType });
  }

  getRisrAssessItemSets(connectionId: string, risrAssessBlueprintId: string): Observable<any> {
    return this.api.get(`${this.endpoint}/${connectionId}/risr-assess/itemsets`, { risrAssessBlueprintId });
  }
}
